import React from 'react'
import { Route, Switch, Redirect, withRouter } from 'react-router-dom'
import PageHOC from '../layout/PageHOC'
import { SERVICE_NBN } from '../constants'
import NbnPlans from '../nbn/NbnPlans'
import NbnFeatures from '../nbn/NbnFeatures'
import NbnAboutSpeeds from '../nbn/NbnAboutSpeeds'
import SubNavigationFloating from '../modules/SubNavigationFloating'
import FaqAndTerms from '../modules/FaqAndTerms'
import NbnFibrePhone from '../modules/NbnFibrePhone'
import ExetelAFriend from '../modules/ExetelAFriend'
import globals from '../globals'
// import SalesforceChat from "../components/SalesforceChat";

class Nbn extends React.Component {
    constructor (props) {
        super(props)

        this.subNav = [
            { title: 'Plans', url: '', icon: 'Plans.svg' },
            { title: 'Exetel-a-friend', url: '/exetel-a-friend', icon: 'Exefriend.svg' },
            { title: 'Features', url: '/features', icon: 'Features.svg' },
            { title: 'Phone', url: '/phone', icon: 'Phone.svg' },
            { title: 'About speeds', url: '/about-speeds', icon: 'Speed.svg' },
            { title: 'Q&A / Terms', url: '/faq-terms', icon: 'QA.svg' }
        ]

        this.anchor = React.createRef()
    }

    componentDidMount () {
        this.props.delayedAnimateIn()
        globals.pushGA4Events('journeyStep', {
            eventInfo: {
                journeyName: 'Nbn Plans',
                stepName: 'View Nbn plan',
                stepNo: '1'
            }
        })
    };

    render () {
        const RenderPhone = () => {
            return <NbnFibrePhone contentUrl='/api/getContent/nbn/phone' />
        }

        const RenderFeatures = () => {
		    return <NbnFeatures hasBgTop />
        }

        const RenderFaqAndTerms = () => {
		    return <FaqAndTerms faqUrl='/api/getContent/nbn/faqs' termsUrl='/api/getContent/nbn/terms' />
        }

        const isPlanPage = this.props.location.pathname === '/broadband/nbn'

        return (
            <div>
                <div ref={this.anchor} />
                <SubNavigationFloating items={this.subNav} url={this.props.match.url} anchor={this.anchor} dontFloat={!isPlanPage} />
                <Switch>
                    <Route exact path={this.props.match.url} component={NbnPlans} />
                    <Route exact path={`${this.props.match.url}/features`} render={RenderFeatures} />
                    <Route exact path={`${this.props.match.url}/exetel-a-friend`} component={ExetelAFriend} />
                    <Route exact path={`${this.props.match.url}/about-speeds`} component={NbnAboutSpeeds} />
                    <Route exact path={`${this.props.match.url}/phone`} render={RenderPhone} />
                    <Route exact path={`${this.props.match.url}/faq-terms`} render={RenderFaqAndTerms} />
                </Switch>
                {/* <SalesforceChat minimisedText="Chat about nbn&trade;" /> */}
            </div>
        )
    }
}

export default PageHOC(withRouter(Nbn), SERVICE_NBN)



// WEBPACK FOOTER //
// ./resources/js/pages/Nbn.js